export default __webpack_public_path__ + "static/media/pdf.df47a25c.svg";